import { Box } from '@primer/react';
import React from 'react';
import { useLiveCheckinDataContext } from './useLiveCheckInDataContext';
import LiveCheckInHocSinh from './LiveCheckInHocSinh';

const LiveCheckInHocSinhList = () => {
    const { filteredData } = useLiveCheckinDataContext();

    return (
        <Box sx={{ display: "grid" }}>
            <Box sx={{
                display: "grid",
                gridTemplateColumns: "100px 300px 120px",
                borderBottom: "1px solid",
                borderBottomColor: "border.default",
                pt: 1,
                pb: 1,
                height: 40,
                alignItems: "center"
            }}>
                <Box sx={{ fontWeight: 600 }}>
                    Ảnh
                </Box>
                <Box sx={{ fontWeight: 600 }}>
                    Học sinh
                </Box>
                <Box sx={{ fontWeight: 600, textAlign: "center" }}>
                    Điểm danh
                </Box>
            </Box >
            <Box sx={{
                overflow: "auto",
                height: `${window.innerHeight - 170}px`
            }}>
                {filteredData.map(data => {
                    return (
                        <LiveCheckInHocSinh data={data} key={data.key} />
                    );
                })}
            </Box>
        </Box>
    );
};

export default LiveCheckInHocSinhList;